module.exports = __webpack_public_path__ + "Gotham-Medium.22b9e0101ea793c9f5e4.ttf";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Medium.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Medium.ttf
// module chunks = 2